export class BarchartVertical {
  title: string;
  barChartLabels: string[] = [];
  barChartData: any[] = [];
  barChartLegend: boolean; 
  barChartType: string;
  barChartOptions: any;
}
